export const CHAT_USER_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
};
